import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

type SidebarItemTextProps = {
  text: string;
  className?: string;
};

export const SidebarItemText: FC<SidebarItemTextProps> = ({ text, className }) => {
  return (
    <h2
      className={twMerge(
        'hidden truncate font-semibold leading-6 text-secondary-700 first-letter:capitalize starting:opacity-0',
        'group-data-[expanded=false]/sidebar:motion-safe:[transition:color_300ms_ease,opacity_450ms_ease,display_1000ms_ease_allow-discrete] group-data-[expanded=false]/sidebar:opacity-0',
        'group-data-[expanded=true]/sidebar:motion-safe:[transition:color_300ms_ease,opacity_1000ms_ease_150ms,display_1000ms_ease_allow-discrete] group-data-[expanded=true]/sidebar:block',
        className
      )}
    >
      {text}
    </h2>
  );
};
